module.exports = __webpack_public_path__ + "img/part4_scene.6e1f333d.png";